<mat-drawer-container class="drawer-container">
  <ng-container id="step-welcome"></ng-container>
  <mat-drawer #sidebar id="step-sidebar" class="pc-sidebar" [mode]="modeValue" opened (openedChange)="onDrawerOpened($event)">
    <nav>
      <div class="navbar-wrapper">
        <div class="m-header">
          <a id="step-logo" href="/home" class="flex align-item-center">
            <img [ngSrc]="companyLogoUrl()" alt="logo" width="100" height="100" priority="true" />
          </a>
        </div>
        <app-vertical-menu [menus]="menus()" />
      </div>
    </nav>
  </mat-drawer>
  <div>
    <app-header />
    <div class="app-container">
      <app-breadcrumb [dashboard]="true" />
      <div class="main-body">
        <div id="step-content" class="page-wrapper">
          <router-outlet />
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</mat-drawer-container>
<app-configuration />
